import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import SuiTypography from "components/SuiTypography";
import GoalButton from "layouts/goals/components/GoalButton";

function DeleteAssetModal({ open, onClose, onConfirm, assetName, isSubmitting }) {
  return (
    <Dialog open={open} onClose={() => !isSubmitting && onClose()} fullWidth maxWidth="xs">
      <DialogTitle>Delete asset?</DialogTitle>
      <DialogContent>
        <SuiTypography variant="button" color="text" display="block">
          Are you sure you want to delete &quot;{assetName}&quot;? It has never been assigned, so
          this only removes the entry. This can&apos;t be undone.
        </SuiTypography>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <GoalButton variant="secondary" onClick={onClose} disabled={isSubmitting}>
          Cancel
        </GoalButton>
        <GoalButton variant="danger" icon="delete" loading={isSubmitting} onClick={onConfirm}>
          Delete
        </GoalButton>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteAssetModal;
